module.exports = __webpack_public_path__ + "img/38.dc929be8.jpg";